//uses gsap

import InViewDetector from "./plugins/inview";

class Doughnut {
  doughnut_tmpl = `
    <div class="statistic">
    <div class="statcircle--container">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 400 400" style="enable-background:new 0 0 400 400;" xml:space="preserve">
        <circle class="statcircle statcircle__bottom" cx="200" cy="200" r="177.7"/>
        <path class="statcircle statcircle__animated" r="177.7" d="M200.6,22.3c97.9,0.3,177.1,79.7,177.1,177.7c0,98.1-79.5,177.7-177.7,177.7S22.3,298.1,22.3,200
            c0-97.8,79-177.2,176.7-177.7"/>
        </svg>
        <div class="statistic__figure">
            <div class="figure__content">
                <span class="fig">{{value}}</span>
                <span class="perc">&#37;</span>
            </div>
        </div>
    </div>
  </div>`;
  percentage = null;
  textcontent = null;
  circle = null;
  doughnuts = null;

  constructor(doughnuts) {
    if (doughnuts instanceof $) {
      this.doughnuts = doughnuts;
      this.init(this.doughnuts);
    } else {
      console.log("Error intializing Doughnut chart, not jQuery Object");
    }
  }

  init(doughnuts) {
    let _t = this;
    doughnuts.each(function (i, e) {
      let value = $(e).data("value");
      let html = _t.doughnut_tmpl.replace("{{value}}", value);

      $(e).html(html)
      new InViewDetector(e, () => _t.drawDoughnut($(e)), {  delay: 500 })
    });
  }

  drawDoughnut(element) {
    if(element.hasClass('animated')) return

    let percentage = element.find('.figure__content .fig');
    let textContent = percentage.text();
    let circle = element.find('.statcircle__animated');

    element.addClass('animated').css('opacity', '1')

    percentage.prop('Counter', 0).animate({
        Counter: textContent
    }, {
        duration: 1000,
        easing: 'swing',
        step: function(now) {
            percentage.text(Math.ceil(now))
        }
    });


    let radius = parseFloat(circle.attr('r'))
    let circumference = 2 * Math.PI * radius

    circle.css({
        strokeDasharray: circumference,
        strokeDashoffset: circumference
    });

    gsap.to(circle, {
        strokeDashoffset: circumference - (textContent / 100) * circumference,
        duration: 1.5,
        ease: "power1.out"
    })
  }
}

$(() => new Doughnut($(".doughnut")));
